/* src/app/modules/spare-parts/service-tickets/service-tickets.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=service-tickets.component.css.map */
